export const mutations = {
  addConfiserie(state, confiserie) {
    state.confiserie = confiserie
  },
  setConfiserie(state, confiserie) {
    state.confiserie = confiserie
  },
  addConfiseries(state, confiserie) {
    state.confiseries = [...confiserie]
  },
  addConfiseriesPage(state, confiserie) {
    state.confiseries = confiserie
  }
}
